import { useEffect, useMemo } from 'react'
import { useFeatureFlags } from 'components/hooks/useFeatureFlags'

const useCookieHelpers = (oneTrustAccessKey: string) => {
  const { getFlag } = useFeatureFlags()
  const releaseCookieConsentBannerTemp = useMemo(
    () => getFlag('releaseCookieConsentBannerTemp') as boolean,
    [getFlag],
  )

  useEffect(() => {
    if (!oneTrustAccessKey || !releaseCookieConsentBannerTemp) return

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'ot-helper-functions'

    script.innerHTML = `
      function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length === 2) {
          return true;
        }
      }

      function reloadOTBanner() {
        var otConsentSdk = document.getElementById("onetrust-consent-sdk");
        if (otConsentSdk) {
          otConsentSdk.remove();
        }

        if (window.OneTrust != null) {
          OneTrust.Init();

          setTimeout(function () {
            OneTrust.LoadBanner();

            var toggleDisplay = document.getElementsByClassName("ot-sdk-show-settings");

            for (var i = 0; i < toggleDisplay.length; i++) {
              toggleDisplay[i].onclick = function (event) {
                event.stopImmediatePropagation();
                window.OneTrust.ToggleInfoDisplay();
              };
            }
          }, 1000);
        }
      }
    `

    document.head.appendChild(script)

    return () => {
      const existing = document.getElementById('ot-helper-functions')
      if (existing) {
        existing.remove()
      }
    }
  }, [oneTrustAccessKey, releaseCookieConsentBannerTemp])
}

export default useCookieHelpers
